module.exports = require('./helpers/bundle-url').getBundleURL('h4RYs') + "logo.c51670a8.svg";